import { updateProfileData, saveUserData, updateUserPassword, addUserData, deleteUserData, updateUserAvatar, saveAssignedBuildings } from '../utils/api'
//import { showLoading, hideLoading } from 'react-redux-loading'
export const RECEIVE_USERS = 'RECEIVE_USERS'
export const UPDATE_USER = 'UPDATE_USER'
export const ADD_USER = 'ADD_USER'
export const DELETE_USER = 'DELETE_USER'
export const UPDATE_AVATAR = 'UPDATE_AVATAR'

export function receiveUsers (users) {
	return {
		type: RECEIVE_USERS,
		users
	}
}

export function handleSaveUser (userId, data) {
	return (dispatch) => {

		return saveUserData(userId, data)
			.then((user) => {
				dispatch(updateUser(user))
			})
	}
}

export function handleAddUser (data) {
	return (dispatch) => {
		return addUserData(data)
			.then((user) => {
				dispatch(addUser(user))
			})
	}
}

export function handleDeleteUser (userId) {
	return (dispatch) => {
		return deleteUserData(userId)
			.then(() => {
				dispatch(deleteUser(userId))
			})
	}
}

export function handleUpdatePassword (userId, password) {
	return (dispatch) => {
		return updateUserPassword(userId, password)
	}
}

export function handleUpdateAvatar (data) {
	return (dispatch) => {
		return updateUserAvatar(data)
			.then((user) => {
				dispatch(updateUser(user))
			})
	}
}

export function handleSaveAssignedBuildings (userId, assignedBuildings) {
	return (dispatch) => {
		return saveAssignedBuildings(userId, assignedBuildings)
			.then((user) => {
				dispatch(updateUser(user))
			})
	}
}

export function updateUser (user) {
	return {
		type: UPDATE_USER,
		user
	}
}

export function addUser (user) {
	return {
		type: ADD_USER,
		user
	}
}

export function deleteUser (userId) {
	return {
		type: DELETE_USER,
		userId
	}
}


// WEBPACK FOOTER //
// ./src/actions/users.js